<div *ngIf="paginacaoSuspensoes" class="ui-grid-row mt-2">
    <h3>{{'AVISOS.SUSPENSAO_INSTITUICAO.TITLE' | translate }}</h3>
    <p-table
        [value]="paginacaoSuspensoes.conteudo"
        [paginator]="true"
        [rows]="paginacaoSuspensoes.tamanhoPagina"
        [totalRecords]="paginacaoSuspensoes.totalItens"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        [loading]="loading"
        [resizableColumns]="true"
        (onLazyLoad)="loadLazy($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align: start" class="col-cpnj">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.NR_CNPJ' | translate }}</th>
                <th style="text-align: start" >{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.INSTITUICAO' | translate }}</th>
                <th style="text-align: start" class="col-data">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.DATA_SUSPENSAO' | translate }}</th>
                <th style="text-align: start" class="col-prazo">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.PRAZO_RESPOSTA' | translate }}</th>
                <th style="text-align: start">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.MOTOVO' | translate }}</th>
                <th class="col-acao">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.ACAO' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex">
            <tr>
                <td class="">{{item.instituicao.nrCnpj}}</td>
                <td class="">{{item.instituicao.nmRazaoSocial}}</td>

                <td class="">{{item.dataSuspensao | date: 'dd/MM/yyyy'}}</td>
                <td class="">{{item.prazoParaResponder}}</td>
                <td class="">{{item.motivo}}</td>
                <td>
                    <div *ngIf="isFiscal">
                        <a (click)="solicitarReativacao(item)">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.SOLICITAR_REATIVACAO' | translate }}</a>
                    </div>
                    <div *ngIf="isGestor">
                        <a (click)="analisarReativacao(item)">{{'AVISOS.SUSPENSAO_INSTITUICAO.LABEL.ANALISAR_REATIVACAO' | translate }}</a>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            Registros página atual: {{paginacaoSuspensoes.totalItensPaginaAtual}} | Registros total: {{paginacaoSuspensoes.totalItens}}
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="6">
                    <app-empty-table [data]="paginacaoSuspensoes.conteudo" [message]="'COMUM.LABEL.LISTA_VAZIA' | translate"></app-empty-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
